import React, { useState } from 'react';
import { TiGroup } from "react-icons/ti";
import { MdAssuredWorkload } from "react-icons/md";
import {
  FaAward,
  FaGraduationCap,
  FaArrowRight
} from "react-icons/fa6";

import students from "../../Assets/students.jpg"
import "./Achievements.css";

// Firebase
import { db } from "../../firebase"; // make sure firebase.js exports "db"
import { collection, addDoc } from "firebase/firestore";

const Achievements = () => {
  const [formData, setFormData] = useState({ name: "", email: "", phone: "" });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // console.log("Submitting: ", formData);
    try {
      await addDoc(collection(db, "submissions"), formData);
      setSubmitted(true);
    } catch (err) {
      console.error("Error saving data:", err);
    }
  };

  return (
    <div className='achievement-section'>
      {/* ===== Title ===== */}
      <div className="title">
        <div className="line"></div>
        <p>Simba Education Consultancy</p>
        <div className="line"></div>
      </div>

      <div className="title-heading">
        <h2>Our services are unmatched.</h2>
      </div>

      {/* ===== Achievements ===== */}
      <div className="achievements-container">
        <div className="achievements">
          <TiGroup className='icon' />
          <h2>8900+</h2>
          <p>Happy Clients</p>
        </div>
        <div className="achievements">
          <MdAssuredWorkload className='icon' />
          <h2>30+</h2>
          <p>Our Partners</p>
        </div>
        <div className="achievements">
          <FaAward className='icon' />
          <h2>100+</h2>
          <p>Awards Achieved</p>
        </div>
        <div className="achievements">
          <TiGroup className='icon' />
          <h2>100+</h2>
          <p>Consultation Workshops</p>
        </div>
      </div>

      {/* ===== Study in Russia Section ===== */}
      <section className="study-info">
        <div className="study-left">
          <div className="study-badge">
            <FaGraduationCap className="badge-icon" />
            Official partner with leading International Universities
          </div>

          <h3 className="study-title">Study both Internationally and locally with Confidence</h3>
          <p className="study-desc">
            Interested in local and international Scholarships? Fill out this short form with your contact details. 
            After submitting, you’ll get direct access to the scholarship application link.
          </p>

          {!submitted ? (
            <form onSubmit={handleSubmit} className="form-container">
              <input
                type="text"
                name="name"
                placeholder="Full Name"
                value={formData.name}
                onChange={handleChange}
                required
              />
              <br /><br />
              <input
                type="email"
                name="email"
                placeholder="Email Address"
                value={formData.email}
                onChange={handleChange}
                required
              />
              <br /><br />
              <input
                type="text"
                name="phone"
                placeholder="Phone Number"
                value={formData.phone}
                onChange={handleChange}
                required
              />
              <br /><br />
              <button type="submit" className="study-btn">
                Submit <FaArrowRight className="arrow" />
              </button>
            </form>
          ) : (
            <div className="study-cta">
              <a
                href="https://apply.studyinchina.academy/"
                target="_blank"
                rel="noopener noreferrer"
                className="study-link"
              >
                Study in China Scholarship <FaArrowRight className="arrow" />
              </a>
              <a
                href="https://findadmission.com/student/signup?redirect_url=https://findadmission.com/dashboard/student/vfair/"
                target="_blank"
                rel="noopener noreferrer"
                className="study-btn"
              >
                Find Admissions <FaArrowRight className="arrow" />
              </a>
            </div>
          )}
        </div>

        <div className="study-right">
          <img
            src={students}
            alt="Students exploring Russian university options"
            className="study-image"
          />
        </div>
      </section>

      {/* ===== Contacts Section ===== */}
      <div className="contacts">
        <div className="contact-text">
          <h1>Get In touch</h1>
          <p>
            At Simba we are committed in providing the highest <br />
            standard of medical services and cutting-edge consultancy.
          </p>

          <h1>Address:</h1>
          <p>
            Diamond Plaza, 2nd Floor on Mutati <br />
            and Masari Road junction on 3rd <br />
            and 4th Parklands Avenue. <br />
          </p>

          <h1>Regional Offices</h1>
          <p>
            Juba, South Sudan, <br />
            Hargeisa, Somalia, <br />
            Kigali, Rwanda.
          </p>


          {/* <div className="web-email">
            <a
              href="https://webmail.simbaeducationconsultants.org/"
              target='_blank'
              rel='noreferrer'
            >
              <button className='mails'>Check Mails</button>
            </a>
          </div> */}
        </div>

        <div className="contact-form">
          <h2>Book Now</h2>
          <div className="form-container">
            <p>Enter Your name</p>
            <input type="text" />
          </div>
          <div className="form-container">
            <p>Enter Your Email</p>
            <input type="email" />
          </div>
          <div className="form-container">
            <p>Insert your message.</p>
            <textarea type="text" />
          </div>
          <button className='submit-btn'>Submit</button>
        </div>
      </div>
    </div>
  );
};

export default Achievements;
